<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

export default {
  components: {
    FontAwesomeIcon
  },

  props: {
    title: {
      type: String,
      required: false,
      default: false
    },
    opened: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      active: false,
      faChevronUp: faChevronUp,
      faChevronDown: faChevronDown
    };
  },
  mounted() {
    this.active = this.opened;
  }
};
</script>

<template>
  <div class="collapse column">
    <div class="header" @click="active = !active">
      <div>{{title}}</div>
      <div class="arrow">
        <font-awesome-icon :icon="active ? faChevronDown : faChevronUp" />
      </div>
    </div>

    <transition name="collapse" mode="in-out">
      <div class="content" v-show="active">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.collapse {
  width: 100%;
}

.collapse .collapse {
  width: 100%;
}

.header {
  padding: 1rem 0 1rem 0;
  color: var(--purple);
  font-size: 1.3rem;
  font-weight: 500;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
  background: #fff;
  z-index: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.header .arrow {
  color: #d8d8d8;
}

.content {
  font-size: 0.9rem !important;
}

.content .header {
  color: var(--pink);
  padding: 0.6rem 0 0.6rem 1rem;
  font-size: 1.2rem;
  border-bottom: none;
}

.content .content {
  padding-left: 1rem;
  margin: 0.6rem 0;
  font-size: 1.2rem;
  border-bottom: none;
}

@media (max-width: 480px) {
  .header {
    font-size: 1.2rem;
    padding: 1.3rem 0.5rem;
  }

  .content .header {
    font-size: 1.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Accordion.vue